import type * as Phaser from "phaser"
import { SCENE } from "../core/keys"
import type { EnemyType, GameData, GameSprite, Upgrade } from "../types"

export interface WaveDebugInspectState {
  gameData: GameData
  dogSprite?: GameSprite
  enemyGroup: Phaser.Physics.Arcade.Group
  projectileGroup: Phaser.Physics.Arcade.Group
  expCoinGroup: Phaser.Physics.Arcade.Group
}

export interface WaveRuntimeApi {
  requestPause(): void
  resumeGame(): void
  resumeAfterShop(): void
  applyUpgradeChoice(upgrade: Upgrade): void
  getUpgradeChoices(): Upgrade[]
  getGameData(): GameData
  setDebugFrozen(frozen: boolean): void
  getDebugInspectState(): WaveDebugInspectState
  finishBossCutscene(): void
  setInfiniteTime(enabled: boolean): void
  spawnEnemyAtPoint(type: EnemyType, x: number, y: number): void
  killAllEnemies(): void
  triggerSectorClear(): void
}

export function getWaveRuntime(scene: Phaser.Scene): WaveRuntimeApi | null {
  const waveScene = scene.scene.get(SCENE.WAVE)
  if (!waveScene) return null
  return waveScene as unknown as WaveRuntimeApi
}
